import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Switch } from '@mui/material';

/**
 * CustomSwitch 컴포넌트 Props
 * @typedef {Object} CustomSwitchProps
 * @property {boolean} value - 스위치의 현재 값
 * @property {Function} onChangeToggle - 스위치 변경 시 호출되는 콜백 함수
 */

const CustomSwitch = ({ value, onChangeToggle, message }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => setModalOpen((prev) => !prev);

  const handleOnChangeSwitch = (e) => {
    setModalOpen(true);
  };

  const handleModalConfirmButton = () => {
    onChangeToggle();
    setModalOpen(false);
  };

  return (
    <>
      <Switch checked={value} onChange={handleOnChangeSwitch} />
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth='xs'
        open={modalOpen}
        onClose={handleCloseModal}
      >
        <DialogTitle>상태 변경</DialogTitle>
        <DialogContent>
          <ConfirmModal>
            <h2>{message}</h2>
          </ConfirmModal>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>취소</Button>
          <Button onClick={handleModalConfirmButton} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ConfirmModal = styled.div`
  h2 {
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
  }
`;

export default CustomSwitch;
